import SwipeReviewView from './SwipeReviewPage';

export default SwipeReviewView;
